const strHtmInstall='<span style="color: #FF00FF">打印控件未安装!点击这里<a href="http://www.lodop.net/download/CLodop_Setup_for_Win32NT_https_3.046Extend.zip" target="_blank">点我下载</a>,安装后请刷新页面或重新进入。</span>';
const strHtmUpdate='<span style="color: #FF00FF">打印控件需要升级!点击这里<a href="http://www.lodop.net/download/CLodop_Setup_for_Win32NT_https_3.046Extend.zip" target="_blank">点我下载</a>,安装后请刷新页面或重新进入。</span>';
const render=(str)=>{
    let div=document.createElement('div');
    div.innerHTML=str;
    div.setAttribute('style','line-height:30px;background-color:#fff;border-bottom:1px solid #eee;padding:0 30px;color:#fff;position:fixed;left:0;top:0;width:100%;');
    let button=document.createElement('div');
    const buttonText=document.createTextNode('X');
    button.setAttribute('style','position:absolute;right:30px;width:20px;height:20px;border-radius:50%;background-color:#ffb100;top:5px;text-align:center;line-height:20px;cursor: pointer;');
    button.appendChild(buttonText);
    button.onclick=function () {
        button.onclick=null;
        button=null;
        div.parentNode.removeChild(div);
        div=null;
    };
    div.appendChild(button);
    document.body.appendChild(div)
};
/**
 * 基础信息
 * @type {object}
 */
export default {
    notInstall:()=>render(strHtmInstall),
    hasUpdate:()=>render(strHtmUpdate)
};
